<template>
    <div v-loading="logs.meta.loading">
        <p class="mt-0 mb-0">
            <template v-for="log in computedLogs">
                {{ log.text }}<br />
            </template>
            <el-table row-key="id" :data="computedLogs"> </el-table>
        </p>
        <app-pagination
            :pagination="logs.meta.pagination"
            @current-change="onPageChange"
            class="mt-20"
        />
    </div>
</template>

<script>
import OrderLogType from "@/constants/order-log-types";

export default {
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            logs: {
                data: [],
                meta: {
                    pagination: null,
                    loading: false,
                },
            },
        };
    },
    created() {
        this.getAuditLogs();
    },
    watch: {
        "order.id"() {
            this.getAuditLogs();
        },
    },
    computed: {
        computedLogs() {
            let logs = this.logs.data.map((log) => {
                let text = `${log.user ? log.user.name : "Guest"} - `;
                let status = "";
                switch (log.type) {
                    case OrderLogType.statusUpdate:
                        text += `${this.$options.filters.capitalize_all(
                            log.data.status,
                        )}`;
                        if (
                            !log.data.checked &&
                            log.data.status !== "order placed"
                        ) {
                            text += " (unchecked)";
                        }
                        status = this.$options.filters.capitalize_all(
                            log.data.status,
                        );
                        break;
                    case OrderLogType.billableEdit:
                        text += "Billable Edit";
                        status = "Billable Edit";
                        break;
                }
                let created = this.$options.filters.florida_short_datetime(
                    log.created_at,
                );
                text += ` - ${this.$options.filters.florida_short_datetime(
                    log.created_at,
                )}`;
                return {
                    id: log.id,
                    name: log.user ? log.user.name : "Guest",
                    status: status,
                    created: created,
                    text: text,
                    comments: log.comments ? log.comments : "",
                };
            });
            //console.log(logs);
            return logs;
        },
    },
    methods: {
        getAuditLogs(page = 1) {
            this.logs.meta.loading = true;
            axios
                .get(`/web-api/audit-log`, {
                    params: {
                        include: "user",
                        model_type: "App\\Order",
                        model_id: this.order.id,
                        type: "status update",
                        page,
                    },
                })
                .then((response) => {
                    this.logs.data = response.data.data;
                    this.logs.meta.pagination = response.data.meta.pagination;
                    //console.log(this.logs.data );
                })
                .finally(() => (this.logs.meta.loading = false));
        },
        onPageChange(page) {
            this.getAuditLogs(page);
        },
    },
};
</script>

<style scoped></style>
